// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "7888") return "css/design_system-0d2c37815f2f9adb.css";
if (chunkId === "2128") return "css/2128-91071b80fab86e34.css";
if (chunkId === "4662") return "css/4662-44eccc0403d5f3f3.css";
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"2044": "34c065af81496449","2429": "a73d2fa285645c40","4170": "7d6d11ecc2d551d2","4372": "b6be809011465250","530": "f36c1bbe5677b7d8","7364": "a8d311b114ec77ce","7572": "f36c1bbe5677b7d8",}[chunkId] + ".css"
}